import { Message } from '@models/recomendations.model';

export const recommnedationsDummy: Message = {
    name: '',
    items: [],
    total_items: 0,
    see_more: false
};
